import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.messages')
  .factory('$messages', messagesObjectFactory);

/* @ngInject */
function messagesObjectFactory($bringozFactory: $bringozFactory,
                               MessagesAPI: BringozApi,
                               Messages_DS: DataStoreConfig) {

  function $messages(id: string) {
    return $bringozFactory(id, MessagesAPI, Messages_DS)
  }

  return $messages
}
